import { useMemo } from "react";

import { HeatMap } from "../calendar/row/heat_map_row/heat_map_item.types";
import { useUtilizationDataProvider } from "./use_utilization_data_provider";

export const useGroupedHeatMapItems = (heatMapItems: HeatMap[]): HeatMap[][] => {
  const { getUtilizationValue } = useUtilizationDataProvider();

  return useMemo(
    () =>
      heatMapItems.reduce<HeatMap[][]>((groupedItems, current, index) => {
        if (getUtilizationValue(current) === getUtilizationValue(heatMapItems[index - 1])) {
          groupedItems[groupedItems.length - 1].push(current);
        } else {
          groupedItems.push([current]);
        }
        return groupedItems;
      }, []),
    [heatMapItems, getUtilizationValue]
  );
};
